jQuery(document).ready(function () {
/*
    if ($('.team').length > 0) {
        if (window.matchMedia("(min-width: 1023px)").matches) {
            if ($('.team_teammate').length > 1) {
                $('.team_carousel').slick({
                    speed: 300,
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                    dots: true,
                    arrows: false,

                });
            }
        }
    }
*/
   $(".team_card").hover(function(){
    $(this).find('.team_card-infos').stop(true, true).fadeToggle();
   })
});
